import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { PatientOverviewQuestionnaireItem } from './questionnaire'

export const PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_LEGAL_NAME]: QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_PREFERRED_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DATE_OF_BIRTH]: QuestionnaireAnswerType.DATE,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_ADDRESS]: QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_GENDER]: QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_SEX]: QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_MEDICAID_ID]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_ORDERING_PRACTITIONER]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DISCHARGE_ASSESSMENT_STATUS]:
    QuestionnaireAnswerType.STRING
}
